export default __webpack_public_path__ + "static/tertiary-image-banner-d22fb664b8478bb5691322d42803064d.png";